(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-dn-open]').forEach(button => {
      if (button.dataset.dnReady) return;
      button.dataset.dnReady = 'true';
      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.dnOpen);
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      });
    });
    root.querySelectorAll('.dn-zoom-dialog').forEach(dialog => {
      if (dialog.dataset.dnReady) return;
      dialog.dataset.dnReady = 'true';
      dialog.querySelector('[data-dn-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    });
    root.querySelectorAll('[data-dn-name]').forEach(input => {
      if (input.dataset.dnReady) return;
      input.dataset.dnReady = 'true';
      input.addEventListener('input', () => {
        const preview = document.getElementById(input.dataset.dnName);
        if (preview) preview.textContent = input.value.trim() || input.placeholder;
      });
    });
    const mobile = root.querySelector('.dn-mobile-nav');
    if (mobile && !mobile.dataset.dnReady) {
      mobile.dataset.dnReady = 'true';
      mobile.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { mobile.open = false; }));
      mobile.addEventListener('keydown', event => { if (event.key === 'Escape') { mobile.open = false; mobile.querySelector('summary')?.focus(); } });
    }
    const model = new URLSearchParams(location.search).get('modele');
    const message = document.getElementById('dn-contact-message');
    if (model && message && !message.value) message.value = message.dataset.modelPrompt.replace('[modele]', model.slice(0,80));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
